<template>
  
  <div>

    <div class="ui large breadcrumb">
      <div class="bold section">{{ title }}</div>
    </div>

    <bookmark-button :label="title" />

    <div class="ui divider"></div>

    <certs-filter ref="filter" @onApply="filter" />

    <div v-if="dayLabel" class="ui grid m-t-5">
      <div class="three wide column">
        <button class="ui icon big button" @click="onDateNav('back')">
          <i class="chevron left icon"></i>
        </button>
      </div>
      <div class="ten wide column">
        <div class="ui basic center aligned segment no-margin no-padding">
          <h3 class="m-t-10">{{ dayLabel }}</h3>
        </div>
      </div>
      <div class="three wide column">
        <div class="ui basic right aligned segment no-margin no-padding">
          <button class="ui icon big button" @click="onDateNav('forward')">
            <i class="chevron right icon"></i>
          </button>
        </div>
      </div>
      <div class="sixteen wide field m-t-5"></div>
    </div>

    <data-table id="daily-certs-dtbl" ref="dtbl" :service="service" :attributes="attributes" :fields="fields" 
      sortBy="id" :autoLoad="false" @onRowClick="onShowCert" />

  </div>

</template>

<script>

  import moment from "@/utils/moment"
  import CertService from "@/services/cert-service"
  import SrvService from "@/services/srv-service"
  import gridPage from "@/mixins/grid-page"
  import CertsFilter from "./filter.vue"

  export default {
    
    name: "DailyCertsPage",

    mixins: [gridPage],

    data() {
      return {       
        title: "Laudos por Dia", 
        service: new CertService(),
        attributes: ["id", "status", "date"],
        fields: [          
          { prop: "id", label: "Número", render: this.renderNumber },
          { prop: "date", label: "Data", render: (cert) => this.$formatDate(cert.date) },
          { prop: "animal.name", model: "Animal", label: "Animal" },
          { prop: "customer.shortName", model: "Customer", label: "Clínica" },
          { prop: "service.description", model: "Service", label: "Serviço", render: this.renderService },
          { prop: "user.name", model: "User", label: "Colaborador", render: (cert) => cert.user.name.toUpperCase() },
          { prop: "financialStatus", label: "Financeiro", render: this.renderFinancialStatus },
          { prop: "certValue", label: "Valor", render: this.renderValue },
        ],
      }
    },

    components: {
      CertsFilter,
    },

    computed: {

      dayLabel() {

        let label = null
        const filter = this.$store.state.pages.filters.financialDailyCerts
        const date = filter ? filter.startDate : null

        if (date)
          label = moment(date).format("dddd[,] DD/MM/YYYY").toLowerCase()

        return label  
      },
    },

    methods: {

      onShowCert(data) {
        this.$router.push(`/procs/certs/${data.row.id}/show?historyBack=true`)
      },

      renderNumber(cert) {

        const statusList = CertService.STATUS

        if (!this.$isSimavet() && cert.status !== "finished")
          cert.status = "maintenance"

        return `<i class="${statusList[cert.status].icon} m-r-10"></i> ${cert.id}`
      },

      renderService(cert) {

        const icon = `<i class="${SrvService.TYPE_ICONS[cert.serviceType.icon].icon} m-r-10"></i>`
        const label = `<div class="ui small label m-l-10">${icon} ${cert.serviceType.description}</div>`

        return cert.service.description + label
      },

      renderFinancialStatus(cert) {

        const status = cert.fdata ? cert.fdata.status : "uninformed"
        const data = CertService.FINANCIAL_STATUS[status]

        return `<i class="${data.icon} m-r-10"></i> ${data.description}`
      },

      renderValue(cert) {

        const value = cert.fdata ? cert.fdata.certValue : 0

        return "R$ " + this.$formatCurrency(value)
      },

      onDateNav(action) {

        let storeFilters = this.$cloneObject(this.$store.state.pages.filters)
        let filter = storeFilters.financialDailyCerts

        if (action == "forward") {
          filter.startDate = moment(filter.startDate).add(1, "days").format("YYYY-MM-DD")
        } else {
          filter.startDate = moment(filter.startDate).subtract(1, "days").format("YYYY-MM-DD")
        }

        filter.endDate = filter.startDate

        this.$store.commit("pages/setFilters", storeFilters)     

        this.$refs.filter.updateFilter(filter)

        this.filter(filter)
      },
    },
  }

</script>